
import axios from 'axios';
import getHeaders from '../../constants/headers';
import { CONSUMER_BASE_URL } from '../BaseURL';

export const customerSearch = async (storeId, data) => {
  return axios({
    method: 'post',
    url:
      CONSUMER_BASE_URL + '/api/secure/v1/store/' + storeId + '/store-customer', // for android use
    headers: await getHeaders(),
    data: JSON.stringify(data),
  });
};
